// eslint-disable-next-line no-restricted-imports
import { useDispatch } from "react-redux";

/**
 * @deprecated
 *
 * Do not use this function. We're moving away from Redux. Use it
 * exclusively when migrating old code to appV2 and is strictly necessary.
 */
export function useDeprecatedDispatch(): { deprecatedDispatch: ReturnType<typeof useDispatch> } {
  const deprecatedDispatch = useDispatch();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  return { deprecatedDispatch };
}
